import React, { useEffect, useState } from "react";
import moment from "moment";
import { Button, Input, Space } from "antd";
import { FONT_SIZE_PX } from "config/theme/constants";
import { PlusCircleFilled, SearchOutlined } from "@ant-design/icons";
import { TableHeaderWrapper, TableHeading } from "./styles";

interface TableHeaderPropsParams {
  callBack?: any;
  showModal?: any;
  placeHolder: string;
  buttonText?: string;
  inputWidth?: string | number;
  disableButton?: boolean;
  disableSearchBox?: boolean;
  leftHeaderText?: string;
  initialData: any;
  columnsKey: Array<string>;
  isShowButton?: boolean;
  isNoSearchRequired?: boolean;
  from?: string;
  customButtonsComponent?: () => React.ReactElement;
  onServerSearch?: (searchValue: string) => void;
  searchLoading?: boolean;
  searchValue?: string;
  setSearchValue?: (value: string) => void;
}

const dateFormats = [
  {
    format: "MM-DD-YYYY",
    regex:
      /^(0[1-9]|1[0-2])(-)(0([1-9])?|1(\d)?|2(\d)?|3([01])?)(-)(19|20)?\d{0,2}?$/,
  },
  {
    format: "DD-MM-YYYY",
    regex:
      /^(0([1-9])?|1(\d)?|2(\d)?|3([01])?)(-)(0[1-9]|1[0-2])(-)(19|20)?\d{0,2}?$/,
  },
  {
    format: "YYYY-MM-DD",
    regex:
      /^(19|20)\d{0,2}(-)(0[1-9]|1[0-2])(-)(0([1-9])?|1(\d)?|2(\d)?|3([01])?)?$/,
  },
  {
    format: "YYYY-MM-DDT",
    regex:
      /^(19|20)\d{0,2}(-)(0[1-9]|1[0-2])(-)(0([1-9])?|1(\d)?|2(\d)?|3([01])?)?T?/,
  },
  {
    format: "MM/DD/YYYY",
    regex:
      /^(0[1-9]|1[0-2])(\/)(0([1-9])?|1(\d)?|2(\d)?|3([01])?)(\/)(19|20)?\d{0,2}?$/,
  },
  {
    format: "DD/MM/YYYY",
    regex:
      /^(0([1-9])?|1(\d)?|2(\d)?|3([01])?)(\/)(0[1-9]|1[0-2])(\/)(19|20)?\d{0,2}?$/,
  },
  {
    format: "YYYY/MM/DD",
    regex:
      /^(19|20)\d{0,2}(\/)(0[1-9]|1[0-2])(\/)(0([1-9])?|1(\d)?|2(\d)?|3([01])?)?$/,
  },
  {
    format: "MM-DD-YYYY",
    regex: /^(0[1-9]|1[0-2])(-)?$/,
  },
  {
    format: "MM-DD-YYYY",
    regex: /^(0[1-9]|1[0-2])(-)(0([1-9])?|1(\d)?|2(\d)?|3([01])?)?(-)?$/,
  },
  {
    format: "DD-MM-YYYY",
    regex: /^(0([1-9])?|1(\d)?|2(\d)?|3([01])?)(-)?$/,
  },
  {
    format: "DD-MM-YYYY",
    regex: /^(0([1-9])?|1(\d)?|2(\d)?|3([01])?)(-)(0[1-9]|1[0-2])?(-)?$/,
  },
  {
    format: "YYYY-MM-DD",
    regex: /^(19|20)\d{0,2}(-)?$/,
  },
  {
    format: "YYYY-MM-DD",
    regex: /^(19|20)\d{0,2}(-)(0[1-9]|1[0-2])?(-)?$/,
  },
  {
    format: "MM/DD/YYYY",
    regex: /^(0[1-9]|1[0-2])(\/)?$/,
  },
  {
    format: "MM/DD/YYYY",
    regex: /^(0[1-9]|1[0-2])(\/)(0([1-9])?|1(\d)?|2(\d)?|3([01])?)?(\/)?$/,
  },
  {
    format: "DD/MM/YYYY",
    regex: /^(0([1-9])?|1(\d)?|2(\d)?|3([01])?)(\/)?$/,
  },
  {
    format: "DD/MM/YYYY",
    regex: /^(0([1-9])?|1(\d)?|2(\d)?|3([01])?)(\/)(0[1-9]|1[0-2])?(\/)?$/,
  },
  {
    format: "YYYY/MM/DD",
    regex: /^(19|20)\d{0,2}(\/)?$/,
  },
  {
    format: "YYYY/MM/DD",
    regex: /^(19|20)\d{0,2}(\/)(0[1-9]|1[0-2])?(\/)?$/,
  },
];

function hasDateValue(obj: any) {
  for (const { format, regex } of dateFormats) {
    if (regex.test(obj)) {
      return { isValid: true, matchingFormat: format };
    }
  }
  return { isValid: false, matchingFormat: null };
}


const TableHeader = ({
  showModal,
  placeHolder,
  buttonText,
  inputWidth = 180,
  disableButton,
  disableSearchBox,
  leftHeaderText,
  initialData,
  callBack,
  columnsKey,
  isShowButton,
  isNoSearchRequired,
  onServerSearch,
  searchLoading = false,
  customButtonsComponent,
  searchValue = "",
  setSearchValue,
}: TableHeaderPropsParams) => {
  const [searchText, setSearchText] = useState("");

  const onSearchHandler = (e: any) => {
    const value = e.target.value.toString();
    setSearchText(value);
    const baseData = [...initialData];
    const filterTable = baseData.filter((o: any) => {
      const filteredAbc = columnsKey.reduce((result: any, keyVal: string) => {
        if (!Array.isArray(o) && o[keyVal]) {
          result[`${keyVal}`] = o[keyVal];
        }
        return result;
      }, {});
      return Object.values(filteredAbc).some((v) => {
        if (typeof v === "boolean") {
          return value?.toLowerCase() === "true" ||
            value.toUpperCase() === "TRUE"
            ? true
            : false;
        }
        const getDateValid: any = hasDateValue(value);
        if (getDateValid?.isValid) {
          const dateVal = moment(String(v)).format(getDateValid.matchingFormat);
          return dateVal?.includes(value);
        }
        const stringValue = String(v)?.toLowerCase();
        return stringValue.includes(value?.toLowerCase());
      });
    });
    if (value === "") {
      return initialData;
    } else {
      return filterTable;
    }
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchText(value);
    if (setSearchValue) {
      setSearchValue(value);
    }
  };

  const handleSearch = (clear?: any) => {
    if (clear === "CLEAR") {
      setSearchText("");
      if (setSearchValue) {
        setSearchValue("");
      }
      if (onServerSearch) {
        onServerSearch("");
      }
    } else if (onServerSearch) {
      onServerSearch(searchText);
    } else {
      const searchData = onSearchHandler({ target: { value: searchText } });
      callBack?.(searchData);
    }
  };

  const renderButtons = () => {
    if (isShowButton === false) {
      return <></>;
    } else if (customButtonsComponent) {
      return customButtonsComponent();
    } else {
      return (
        <Button
          type="primary"
          icon={<PlusCircleFilled />}
          onClick={showModal}
          disabled={disableButton}
          style={{ fontSize: FONT_SIZE_PX.xs }}
        >
          {buttonText}
        </Button>
      );
    }
  };

  useEffect(() => {
    setSearchText(searchValue || "");
  }, [initialData]);

  return (
    <TableHeaderWrapper>
      <Space
        className={
          leftHeaderText ? "header-container-with-head" : "header-container"
        }
      >
        {leftHeaderText && <TableHeading>{leftHeaderText}</TableHeading>}
        <div style={{ display: "flex" }}>
          {isNoSearchRequired ? (
            <></>
          ) : (
            <Input
              placeholder={placeHolder}
              style={{
                width: inputWidth,
                marginRight: 10,
              }}
              onChange={handleSearchChange}
              value={searchText}
              allowClear
              disabled={disableSearchBox}
              onClear={() => handleSearch("CLEAR")}
              onPressEnter={handleSearch}
              suffix={
                <Button
                  icon={<SearchOutlined style={{ cursor: "pointer" }} />}
                  onClick={handleSearch}
                  disabled={disableSearchBox}
                  loading={searchLoading}
                  style={{
                    background: "transparent",
                    border: "none",
                    boxShadow: "none",
                    padding: 0,
                    height: "auto",
                    marginRight: 0,
                  }}
                />
              }
            />
          )}
          {renderButtons()}
        </div>
      </Space>
    </TableHeaderWrapper>
  );
};

export default TableHeader;
